import { toCamelCase } from '@config/utils';

export default {
    mixins: [

    ],
    components: {
    },
    props: {
        value: {
            type: Object,
            default: () => {
                return {
                };
            }
        },
        allowExport: {
            type: Boolean,
            default: false,
        },
        notDataMsg: {
            type: String,
            default: 'global.no-data',
        },
    },
    data() {
        return {
            item: this.value,
        }
    },
    computed: {
        itemTitle() {
            return this.item?.title ?? '';
        },
        itemLabel() {
            return this.item?.label ?? '';
        },
        itemClass() {
            return this.item?.class;
        },
        itemFooter() {
            return this.item?.footer ?? null;
        },
        chartComponent() {
            return `${toCamelCase(this.chartType)}Chart`;
        },
        chartConfig() {
            return this.item?.chart ?? {};
        },
        chartType() {
            return this.chartConfig.type ?? 'line';
        },
        chartId() {
            return `bar-chart-${this.chartType}`;
        },
        chartDatasetIdKey() {
            return this.chartConfig?.datasetIdKey ?? 'label';
        },
        chartOptions() {
            return this.chartConfig?.options ?? {responsive: true, maintainAspectRatio: false};
        },
        chartPlugins() {
            return this.chartConfig?.plugins ?? [];
        },
        chartData() {
            return this.chartConfig?.data ?? null;
        },
        chartLabels() {
            return this.chartData?.labels ?? [];
        },
        chartDatasets() {
            return this.chartData?.datasets ?? [];
        },
        chartCssClasses() {
            return this.chartConfig?.cssClasses || '';
        },
        chartStyles() {
            return this.chartConfig?.styles || {};
        },
        chartWidth() {
            return this.chartConfig?.width || null;
        },
        chartHeight() {
            return this.chartConfig?.height || null;
        },
        hasData() {
            return !!this.chartDatasets?.length;
        },
        notDataInfo() {
            return this.$t(`${this.notDataMsg}`);
        }
    },
    methods: {
        createChart(ctx) {
            if(!ctx) return null;

            // return new Chart(ctx, {
            //     type: 'bar',
            //     data: {
            //     labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
            //     datasets: [{
            //         label: '# of Votes',
            //         data: [12, 19, 3, 5, 2, 3],
            //         borderWidth: 1
            //     }]
            //     },
            //     options: {
            //     scales: {
            //         y: {
            //         beginAtZero: true
            //         }
            //     }
            //     }
            // });
        }
    },
    watch:{
        'value': {
            deep: true,
            immediate: false,
            handler(val){
                this.item = val;
            },
        },
    },
};
